export default {
  caseData: 1,
  employeeData: 2,
}
